<div class="pos-header-ops" role="group" [attr.aria-label]="'pos.shell.opsGroup' | translate">
  @if (staff(); as current) {
    <button
      type="button"
      class="pos-header-ops__chip pos-header-ops__chip--operator"
      [matMenuTriggerFor]="operatorMenu"
      [attr.title]="current.name"
      [attr.aria-label]="'pos.staff.operatorMenuAria' | translate"
    >
      <mat-icon>badge</mat-icon>
      <span class="pos-header-ops__operator-name">{{ current.name }}</span>
      <mat-icon class="pos-header-ops__chevron" aria-hidden="true">expand_more</mat-icon>
    </button>
    <mat-menu #operatorMenu="matMenu" xPosition="before">
      <button type="button" mat-menu-item (click)="onOperatorClick()">
        <mat-icon>swap_horiz</mat-icon>
        <span>{{ 'pos.staff.changeOperator' | translate }}</span>
      </button>
      <button type="button" mat-menu-item (click)="clearOperator()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'pos.staff.clear' | translate }}</span>
      </button>
    </mat-menu>
  }

  @if (showTipShiftChip()) {
    <!-- Con turno de caja el tip va embebido; aquí solo propinas standalone.
         Acción (abrir panel) solo con tip_shifts.create; si no, solo estado. -->
    @if (canOpenTipShiftPanel()) {
      <button
        type="button"
        class="pos-header-ops__chip"
        [class.pos-header-ops__chip--warn]="tipShiftBlocked() && !tipShiftSetupIncomplete()"
        [class.pos-header-ops__chip--info]="tipShiftSetupIncomplete()"
        [class.pos-header-ops__chip--ok]="tipShiftActive()"
        (click)="openTipShift()"
        [attr.title]="tipShiftButtonLabelKey() | translate"
      >
        <mat-icon aria-hidden="true">{{ tipShiftButtonIcon() }}</mat-icon>
        <span class="pos-header-ops__label pos-header-ops__label--full">{{
          tipShiftButtonLabelKey() | translate
        }}</span>
        <span class="pos-header-ops__label pos-header-ops__label--compact">{{
          tipShiftButtonCompactKey() | translate
        }}</span>
      </button>
    } @else {
      <span
        class="pos-header-ops__chip pos-header-ops__chip--status"
        [class.pos-header-ops__chip--warn]="tipShiftBlocked() && !tipShiftSetupIncomplete()"
        [class.pos-header-ops__chip--info]="tipShiftSetupIncomplete()"
        [class.pos-header-ops__chip--ok]="tipShiftActive()"
        [attr.title]="tipShiftButtonLabelKey() | translate"
        role="status"
      >
        <mat-icon aria-hidden="true">{{ tipShiftButtonIcon() }}</mat-icon>
        <span class="pos-header-ops__label pos-header-ops__label--full">{{
          tipShiftButtonLabelKey() | translate
        }}</span>
        <span class="pos-header-ops__label pos-header-ops__label--compact">{{
          tipShiftButtonCompactKey() | translate
        }}</span>
      </span>
    }
  }

  @if (showCashShiftChip()) {
    @if (canOpenCashShiftPanel()) {
      <button
        type="button"
        class="pos-header-ops__chip"
        [class.pos-header-ops__chip--warn]="cashShiftBlocked()"
        [class.pos-header-ops__chip--ok]="cashShiftOpen()"
        (click)="openCashShift()"
        [attr.title]="cashShiftButtonLabelKey() | translate"
        [attr.aria-label]="cashShiftButtonLabelKey() | translate"
      >
        <mat-icon aria-hidden="true">{{ cashShiftButtonIcon() }}</mat-icon>
        <span class="pos-header-ops__label pos-header-ops__label--full">{{
          cashShiftButtonLabelKey() | translate
        }}</span>
        <span class="pos-header-ops__label pos-header-ops__label--compact">{{
          cashShiftButtonCompactKey() | translate
        }}</span>
      </button>
    } @else {
      <span
        class="pos-header-ops__chip pos-header-ops__chip--status"
        [class.pos-header-ops__chip--warn]="cashShiftBlocked()"
        [class.pos-header-ops__chip--ok]="cashShiftOpen()"
        [attr.title]="cashShiftButtonLabelKey() | translate"
        role="status"
        [attr.aria-label]="cashShiftButtonLabelKey() | translate"
      >
        <mat-icon aria-hidden="true">{{ cashShiftButtonIcon() }}</mat-icon>
        <span class="pos-header-ops__label pos-header-ops__label--full">{{
          cashShiftButtonLabelKey() | translate
        }}</span>
        <span class="pos-header-ops__label pos-header-ops__label--compact">{{
          cashShiftButtonCompactKey() | translate
        }}</span>
      </span>
    }
  }
</div>
